import httpClient from './httpClient'
import axios from 'axios'
import { CONFIG_URL } from '@/config/envs.js'

export default {
  async getAllVideos(isDeleting) {
    let url = '/videos/all'
    if (isDeleting) url += '?status=DELETING'
    const ret = await httpClient.get(url)
    return ret
  },
  async getAllVideosAndBin(query) {
    let url = '/videos/all?all_status=1'
    let ret = null
    if (query?.page || query?.limit) {
      ret = await httpClient.get(url, {
        params: query,
      })
    } else {
      ret = await httpClient.get(url)
    }
    return ret
  },
  async getVideoConfig(libraryID, videoID) {
    const { data } = await axios.get(
      `${CONFIG_URL}/${libraryID}/${videoID}.json?date=${new Date().getTime()}`
    )
    return data
  },
  async getVideos(query) {
    const ret = await httpClient.get('/videos', {
      params: query,
    })
    return ret
  },
  async getAVideo(videoId, getLogs) {
    let url = `/videos/${videoId}`
    if (getLogs) url += '?all_logs=1'
    const ret = await httpClient.get(url)
    return ret
  },
  async getVideoStatus() {
    const ret = await httpClient.get('/videos/count')
    return ret
  },
  async createVideo(body) {
    const ret = await httpClient.post('/videos', body)
    return ret
  },
  async updateVideo(video, id) {
    const ret = await httpClient.put(`/videos/${id}`, video)
    return ret
  },
  async getVideoStorageSize(id) {
    const ret = await httpClient.get(`/videos/${id}?storage_size_details=1`)
    return ret
  },
  async updateMultipleVideos(videos) {
    const ret = await httpClient.put('/videos', videos)
    return ret
  },
  async setRealtimeAnalytics(videoId, payload) {
    const ret = await httpClient.post('/player/?type=video', {
      video_id: videoId,
      realtimeAnalytics: payload,
    })
    return ret
  },
  async deleteVideo(id) {
    const ret = await httpClient.delete(`/videos/${id}`, {})
    return ret
  },
  async deleteMultipleVideos(videos) {
    const ret = await httpClient.delete('/videos', { data: videos })
    return ret
  },
  async getVideoUploadUrl(id) {
    const ret = await httpClient.put(`/videos/${id}/upload`, {})
    return ret
  },
  async sendVideo(putEndpoint, file) {
    return await fetch(putEndpoint, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  async attachVideoToFolder(videoId, folderId) {
    const ret = await httpClient.put(`/videos/${videoId}`, {
      folder_id: folderId,
    })
    return ret
  },
  async addThumbnailToVideo(videoId, formData) {
    const ret = await httpClient.post(`/thumbs/${videoId}`, formData)
    return ret
  },
  async reencodeVideo(videoId) {
    const ret = await httpClient.post(`/videos/${videoId}?reencode`, videoId)
    return ret
  },
  async addThumbnailToPauseVideo(videoId, formData) {
    const ret = await httpClient.post(`/thumbs/${videoId}?type=pause`, formData)
    return ret
  },
  async addThumbnailToEndVideo(videoId, formData) {
    const ret = await httpClient.post(`/thumbs/${videoId}?type=end`, formData)
    return ret
  },
  async deleteThumbnailVideo(videoId) {
    const ret = await httpClient.delete(`/thumbs/${videoId}`)
    return ret
  },
  async deleteThumbnailPauseVideo(videoId, thumbName) {
    const ret = await httpClient.delete(
      `/thumbs/${videoId}?type=pause&thumbName=${thumbName}`
    )
    return ret
  },
  async deleteThumbnailEndVideo(videoId) {
    const ret = await httpClient.delete(`/thumbs/${videoId}?type=end`)
    return ret
  },
  async addSubtitleToVideo(videoId, formData) {
    const ret = await httpClient.post(`/subtitles/${videoId}`, formData)
    return ret
  },
  async updateVideoSubtitleContent(videoId, formData) {
    const ret = await httpClient.put(`/subtitles/${videoId}`, formData)
    return ret
  },
  async updateDefaultSubtitle(data) {
    const ret = await httpClient.post('/player?type=video', data)
    return ret
  },
  async setPlayerPixel(videoId, customPixels) {
    const ret = await httpClient.post('/player?type=video', {
      video_id: videoId,
      customPixels,
    })
    return ret
  },
  async deleteSubtitleFromVideo(videoId, srclang) {
    const ret = await httpClient.delete(`/subtitles/${videoId}`, {
      data: {
        srclang: srclang,
      },
    })
    return ret
  },
  async deleteAudioFromVideo(id) {
    const ret = await httpClient.delete(`/audio/${id}`)
    return ret
  },
  async updateVideoPlayback(videoId, payload) {
    const ret = await httpClient.put(`/videos/${videoId}`, {
      playback: payload,
    })
    return ret
  },
  async recoverDeletedVideo(data) {
    const ret = await httpClient.post('/videos/recover', data)
    return ret
  },
  async cloneVideo(videoId) {
    const ret = await httpClient.post(`/videos/${videoId}?copy`)
    return ret
  },
}
